import React from 'react'

type Props = {}

const SignupPage = (props: Props) => {
  return (
    <div>SignupPage</div>
  )
}

export default SignupPage